module.exports = __webpack_public_path__ + "static/media/check.9a76b3b8.png";